/**
 * Node/link inspector payloads are expensive; cache per filter + selection within the app session.
 * Widget resets these queries when page filters (period, org, user, channel) change.
 */
var FIVE_MINUTES_MS = 5 * 60 * 1000;
var THIRTY_MINUTES_MS = 30 * 60 * 1000;
export var communicationNetworkGraphInspectorQueryOptions = {
    staleTime: FIVE_MINUTES_MS,
    cacheTime: THIRTY_MINUTES_MS
};
